import React from "react";
import "./styles/RepresentativePerformanceNonResidence.scss";
import { useTranslation } from "react-i18next";

const RepresentativePerformanceNonResidence = () => {
  const { t } = useTranslation();
  const contents = t("trackRecord.representative.nonResidence.content", { returnObjects: true }) as { name: string; path: string }[];
  return (
    <>
      <div className="representative_performance_non_residence_wrap">
        <h2 className="title">{t("trackRecord.representative.nonResidence.title")}</h2>
        <div className="content">
          {contents.map((content: { name: string; path: string }, index: number) => {
            return (
              <div className={`card card_${index}`} key={`${content.name}_${index}`}>
                <div className="img_box">
                  <img src={content.path} alt={content.name} />
                </div>
                <div className="name">{content.name}</div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default RepresentativePerformanceNonResidence;
